module.exports = __webpack_public_path__ + "img/wrench.7b3fc39d.svg";